














import { Component, Emit, Vue } from "vue-property-decorator";

@Component
export default class TransitionExpand extends Vue {
  name = "TransitionExpand";

  @Emit()
  enter(element: HTMLElement) {
    const width = getComputedStyle(element).width;

    element.style.width = width;
    element.style.position = "absolute";
    element.style.visibility = "hidden";
    element.style.height = "auto";

    const height = getComputedStyle(element).height;

    element.style.width = "";
    element.style.position = "";
    element.style.visibility = "visible";
    element.style.height = "0px";

    // Force repaint to make sure the
    // animation is triggered correctly.
    getComputedStyle(element).height;

    // Trigger the animation.
    // We use `requestAnimationFrame` because we need
    // to make sure the browser has finished
    // painting after setting the `height`
    // to `0` in the line above.
    requestAnimationFrame(() => {
      element.style.height = height;
    });
  }

  @Emit()
  afterEnter(element: HTMLElement) {
    element.style.height = "auto";
  }

  @Emit()
  leave(element: HTMLElement) {
    const height = getComputedStyle(element).height;

    element.style.height = height;

    // Force repaint to make sure the
    // animation is triggered correctly.
    getComputedStyle(element).height;

    requestAnimationFrame(() => {
      element.style.height = "0";
    });
  }
}
